import React from 'react';
import { Anchor, Text, theme } from '@veeqo/ui';

export const MessageEl = ({
  preText,
  postText,
  linkText,
  href,
}: {
  preText?: string;
  postText?: string;
  linkText?: string;
  href?: string;
}) => (
  <span>
    {!!preText && <Text variant="body">{preText}</Text>}
    {!!linkText && (
      <Anchor href={href} rel="noopener noreferrer" style={{ padding: `0 ${theme.sizes.xs}` }}>
        {` ${linkText} `}
      </Anchor>
    )}
    {!!postText && <Text variant="body">{postText}</Text>}
  </span>
);
